import {
  HomeIcon,
  CreditCardIcon,
  TomoIqIcon,
  PaymentsIcon,
  RewardsIcon,
  ReferralsIcon,
  StatementsIcon,
  SettingsIcon,
  TransactionsIcon,
  SupportIcon,
  MoreIcon,
  BoostIcon,
  SupportalIcon,
  CreditMonitoringIcon,
} from "components/common/Svg";
import {
  allowRole,
  denyRole,
  allowLoggedIn,
  denyDomain,
} from "./utils";

/**
 * When adding a new page, key+path should match so that nav bar can do its thing know if it's selected.
 * Make sure to add something to REDIRECT_CONFIG if they can't access the standard pages be default (i.e. they're not credit_card user)
 * Hierarchy matters when defining access rules.
 */

export const DASHBOARD = {
  key: "dashboard",
  Icon: HomeIcon,
  path: "/",
  title: "Home",
  accessRules: [
    allowLoggedIn(),
  ],
};

export const CARD = {
  key: "card",
  Icon: CreditCardIcon,
  path: "/card",
  title: "Card",
  accessRules: [
    allowRole("credit_card"),
  ],
};

export const TOMO_ISSUING = {
  key: "business",
  Icon: CreditCardIcon,
  path: "/business",
  title: "Business",
  accessRules: [
    // TODO: Update before going live
    // Allow `admin` or `*@tomocredit.com` only for testing
    denyDomain("tomocredit.com"),
    denyDomain("www.tomocredit.com"),
    allowRole("admin"),
  ],
};

export const PAYMENTS = {
  key: "payments",
  Icon: PaymentsIcon,
  path: "/payments",
  title: "Payments",
  navBarSettings: {
    mobileNav: {
      title: "Pay",
    },
  },
  accessRules: [
    allowRole("credit_card"),
    allowRole("user_terminated_with_balance"),
  ],
};

export const ACTIVITY = {
  key: "activity",
  Icon: TransactionsIcon,
  path: "/activity",
  title: "Activity",
  accessRules: [
    allowRole("credit_card"),
  ],
};

export const REWARDS = {
  key: "rewards",
  Icon: RewardsIcon,
  path: "/rewards",
  title: "Rewards",
  accessRules: [
    allowRole("credit_card"),
  ],
};

export const REFERRALS = {
  key: "referrals",
  Icon: ReferralsIcon,
  path: "/referrals",
  title: "Referrals",
  exactRolesRequired: true,
  accessRules: [
    denyRole("user_terminated_with_balance"),
    allowRole("ambassador"),
  ],
};

export const STATEMENTS = {
  key: "statements",
  Icon: StatementsIcon,
  path: "/statements",
  title: "Statements",
  accessRules: [
    allowRole("credit_card"),
    allowRole("user_terminated_with_balance"),
  ],
};

export const SETTINGS = {
  key: "settings",
  Icon: SettingsIcon,
  path: "/settings",
  title: "Settings",
  accessRules: [
    allowRole("credit_card"),
    denyRole("boost_onboarding"),
    allowLoggedIn()],
};

export const SUPPORT = {
  key: "support",
  Icon: SupportIcon,
  path: "/support",
  title: "Get Help",
  accessRules: [
    allowRole("credit_card"),
  ],
};

export const TERMINATE = {
  key: "terminate",
  path: "/terminate",
  title: "Support",
  accessRules: [
    allowRole("credit_card"),
  ],
};

export const MORE = {
  key: "more",
  Icon: MoreIcon,
  path: "/more",
  title: "More",
  navBarSettings: {
    desktopNav: {
      hide: true,
    },
  },
  accessRules: [
    allowRole("credit_card"),
  ],
};

export const NOTIFICATIONS = {
  key: "notifications",
  path: "/notifications",
  title: "Notifications",
  accessRules: [
    allowRole("credit_card"),
  ],
};

export const CREDIT_MONITORING = {
  key: "credit-monitoring",
  path: "/credit-monitoring",
  title: "Credit Monitoring",
  navBarSettings: {
    mobileNav: {
      title: "Credit",
    },
  },
  Icon: CreditMonitoringIcon,
  accessRules: [
    allowRole("user_with_credit_monitoring"),
  ],
};

export const CREDIT_REPORT = {
  key: "credit-report",
  path: "/credit-report",
  title: "Credit Report",
  accessRules: [
    allowRole("credit_report_eligible"),
    allowRole("credit_report_enrolled"),
  ],
};

export const TOMO_BOOST = {
  key: "boost",
  Icon: BoostIcon,
  path: "/boost",
  title: "Boost",
  navBarSettings: {
    mobileNav: {
      title: "Boost",
    },
  },
  accessRules: [
    allowRole("user_with_credit_boost"),
  ],
};

export const TOMO_IQ = {
  key: "tomo-iq",
  Icon: TomoIqIcon,
  path: "/tomo-iq",
  title: "TomoIQ",
  accessRules: [
    allowRole("user_with_credit_boost_vip"),
  ],
};

export const SUPPORTAL = {
  key: "supportal",
  Icon: SupportalIcon,
  path: "/supportal",
  title: "Supportal",
  accessRules: [
    allowRole("admin"),
    allowRole("customer_support"),
    allowRole("customer_support_readonly"),
  ],
};

export const REDIRECT_CONFIG = {
  user_terminated_with_balance: PAYMENTS.path,
  user_with_credit_monitoring: CREDIT_MONITORING.path,
  user_with_credit_boost: TOMO_BOOST.path,
};

export const ADMIN_CONFIG = {
  accessRules: [
    denyRole("user_terminated_with_balance"),
    allowRole("admin"),
  ],
};

export const isSupport = (page) => {
  return page.key === SUPPORT.key;
};